/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S3_Item5Inputs */

const tr_hakkimizda_s3_item5 = /** @type {(inputs: Hakkimizda_S3_Item5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapay zeka: Anthropic Claude, Google Gemini ve OpenAI GPT modelleri`)
};

const en_hakkimizda_s3_item5 = /** @type {(inputs: Hakkimizda_S3_Item5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artificial intelligence: Anthropic Claude, Google Gemini and OpenAI GPT models`)
};

const de_hakkimizda_s3_item5 = /** @type {(inputs: Hakkimizda_S3_Item5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Künstliche Intelligenz: Modelle von Anthropic Claude, Google Gemini und OpenAI GPT`)
};

const ru_hakkimizda_s3_item5 = /** @type {(inputs: Hakkimizda_S3_Item5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Искусственный интеллект: модели Anthropic Claude, Google Gemini и OpenAI GPT`)
};

/**
* | output |
* | --- |
* | "Artificial intelligence: Anthropic Claude, Google Gemini and OpenAI GPT models" |
*
* @param {Hakkimizda_S3_Item5Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s3_item5 = /** @type {((inputs?: Hakkimizda_S3_Item5Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S3_Item5Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s3_item5(inputs)
	if (locale === "de") return de_hakkimizda_s3_item5(inputs)
	if (locale === "ru") return ru_hakkimizda_s3_item5(inputs)
	return tr_hakkimizda_s3_item5(inputs)
});